import Utils from './utils'
export default () => {
  return Utils
}



// WEBPACK FOOTER //
// ./src/utils/index.js